import LOGIN_MUTATION from './login.graphql'

export {LOGIN_MUTATION}


// WEBPACK FOOTER //
// ./src/modules/login/graphql/index.ts